export default "__VITE_ASSET__97e4deaf__"